export default __webpack_public_path__ + "static/media/about-team-21.e5b99c5f.jpg";